// http/getBearer.ts
import { msalInstance } from '../index';
import { itsRequest } from './authConfig';
import {
  AccountInfo,
  AuthenticationResult,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';

const LAST_ACCOUNT_KEY = 'bluu:lastAccountId';

export default async function getBearer(): Promise<string | null> {
  let account: AccountInfo | null = msalInstance.getActiveAccount();
  console.log('MSAL: Active account =', account);

  if (!account) {
    const all = msalInstance.getAllAccounts();
    if (all.length === 0) {
      console.warn('MSAL: Ingen kontoer i cache.');
      return null;
    }

    const lastId = localStorage.getItem(LAST_ACCOUNT_KEY);

    if (lastId) {
      account =
        all.find(
          (a) => a.homeAccountId === lastId || a.localAccountId === lastId
        ) ?? all[0];
    } else {
      account = all[0];
    }

    msalInstance.setActiveAccount(account);
    localStorage.setItem(LAST_ACCOUNT_KEY, account.homeAccountId);
  }

  // Kan fint droppes – MSAL håndterer exp selv – men jeg lar det stå siden du hadde det.
  const exp = (account.idTokenClaims as any)?.exp as number | undefined;
  const forceRefresh = exp ? new Date(exp * 1000) < new Date() : true;

  try {
    const response: AuthenticationResult =
      await msalInstance.acquireTokenSilent({
        ...itsRequest,
        account,
        forceRefresh,
      });

    if (!response.accessToken) {
      console.error('MSAL: accessToken mangler i responsen.');
      return null;
    }

    // ⚠️ VIKTIG: KUN selve accessToken, IKKE "Bearer "
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      console.warn('MSAL: trenger interaksjon, kjører loginRedirect…');
      await msalInstance.loginRedirect(itsRequest);
      return null;
    }

    console.error('MSAL: Token-henting feilet:', error);
    return null;
  }
}
